export default __webpack_public_path__ + "static/media/icon_solid_search.98ab74b1.svg";